module.exports = __webpack_public_path__ + "img/exclamation-mark 1.3ca5a412.svg";